/* All the global variables, mixins goes here */
@use "sass:math";
@import '../../../../static/scss/resources/default.variables.scss';
@import '../../../../static/scss/resources/default.style.scss';

  /** Grant Wizard CSS **/

/**
  CSS to make db object type table
  fixed so that tbody content may
  scroll
 */

.db_objects_container  {
  height: 100%;
  padding: 0;
}

.db_objects_grid {
  height: calc(100% - 15px);
}

.db_objects_filter {
  & .input-group-text {
    background: $input-bg;
  }

  & .form-control {
    border-left: none;
  }
}

.object_type_table {
  height: calc(100% - 15px);
  display: block;
  padding: 0;
  overflow-y: hidden !important;
}

.object_type_table thead {
  display: table;
  width: 100%;
}

.object_type_table thead tr {
  position: relative;
  display: block;
  width: 100%;
  border-bottom: $panel-border;
}

.object_type_table tbody {
  display: block;
  overflow: auto;
  width: 100%;
  /* 100% minus thead height */
  height: calc(100% - 40px);
}

.object_type_table tbody tr {
  max-width: 100%;
  width: 100%;
}

.object_type_table tbody tr td {
  background-position: 4px 4px;
  border-radius: 0;
}

.object_type_table tbody tr td:nth-child(1),
.object_type_table thead tr th:nth-child(1) {
  width: 28px;
  min-width: 28px;
}

.object_type_table tbody tr td:nth-child(2) {
  width: 161px;
  min-width: 161px;
  max-width: 161px;
}

.object_type_table thead tr th:nth-child(2) {
  width: 161px;
  min-width: 161px;
  max-width: 161px;
}

.object_type_table tbody tr td:nth-child(3) {
  width: 109px;
  min-width: 109px;
  max-width: 109px;
}

.object_type_table thead tr th:nth-child(3) {
  width: 109px;
  min-width: 109px;
  max-width: 109px;
}

.object_type_table thead tr th:nth-child(4) {
  width: 100%;
}

.object_type_table tbody tr td:nth-child(4) {
  width: 100%;
  max-width: 100%;
}

/** Custom styling for Codemirror field **/
.wizard-right-panel_content {
  border: 1px $color-gray-light;
  padding: 0.5rem 0rem;
  height: calc(100% - #{$footer-height-calc});
}

.wizard-right-panel_content .CodeMirror {
  border: 1px solid $color-gray-light;
  height: 100% !important;
  min-height: 100% !important;
}

.wizard-right-panel_content .CodeMirror-linenumber {
  background: $color-gray-light;
  border-right: none;
}

.grant_wizard_container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

#grantWizardDlg {
  padding-top: 0em;

}

.grant-wizard-objcol {
  min-width: 8em !important;
  width: 8em !important;
}

.grant-wizard-panel-content {
  padding-top: 0.9em !important;
}
